//
//
//
//
//
//
//
//
//
//
export default {
  inject: ["main"]
};